import { z } from 'zod';

import { CollectionFileSchema } from './File.schema';
import { Order } from './Order';

import { DiagramSchema } from './Diagram.schema';

export const ProjectDesignSchema = z.object({
    id: z.string(),
    slug: z.string().default(''),
    name: z.string(),
    diagrams: DiagramSchema.shape.id.array(),
    // @ts-expect-error this works
    orders: z.array(z.ZodType<Order>),
    files: CollectionFileSchema.array(),
});

export type ProjectDesign = z.infer<typeof ProjectDesignSchema>;

export const ProjectDesignTeaserSchema = ProjectDesignSchema.pick({
    id: true,
    slug: true,
    name: true,
    diagrams: true,
});

export type ProjectDesignTeaser = z.infer<typeof ProjectDesignTeaserSchema>;
